import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingStore } from '../onboarding.store';

const FALLBACK_ROUTE = '/dashboard';

/**
 * `/onboarding` is no longer a page: the setup guide lives in the top bar. The
 * path still opens it, including for a company with nothing left to do, and
 * leaves the user on whatever they were viewing.
 */
export const onboardingGuideGuard: CanActivateFn = () => {
	const router = inject(Router);
	inject(OnboardingStore).openGuide();

	const current = router.url.split('?')[0];
	return router.parseUrl(
		current && current !== '/' && current !== '/onboarding' ? router.url : FALLBACK_ROUTE,
	);
};
